/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iupac_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each code is replaced by a character class of the bases it represents — N becomes [ACGT], R becomes [AG] — and plain bases are left unchanged, producing a pattern that matches every possible sequence of the motif.`)
};

const es_iupac_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada código se reemplaza por una clase de caracteres con las bases que representa — N se convierte en [ACGT], R se convierte en [AG] — y las bases simples se dejan sin cambios, produciendo un patrón que coincide con cada posible secuencia del motivo.`)
};

const de_iupac_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder Code wird durch eine Zeichenklasse der von ihm repräsentierten Basen ersetzt — N wird zu [ACGT], R wird zu [AG] — und einfache Basen bleiben unverändert, wodurch ein Muster entsteht, das jede mögliche Sequenz des Motivs erfasst.`)
};

const nl_iupac_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke code wordt vervangen door een tekenklasse van de basen die hij vertegenwoordigt — N wordt [ACGT], R wordt [AG] — en gewone basen blijven ongewijzigd, wat een patroon oplevert dat elke mogelijke sequentie van het motief matcht.`)
};

const fr_iupac_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque code est remplacé par une classe de caractères des bases qu'il représente — N devient [ACGT], R devient [AG] — et les bases simples restent inchangées, produisant un motif qui correspond à toutes les séquences possibles du motif.`)
};

const it_iupac_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni codice viene sostituito da una classe di caratteri delle basi che rappresenta — N diventa [ACGT], R diventa [AG] — e le basi semplici restano invariate, producendo un pattern che corrisponde a ogni possibile sequenza del motivo.`)
};

const pt_br2_iupac_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada código é substituído por uma classe de caracteres com as bases que representa — N se torna [ACGT], R se torna [AG] — e as bases simples permanecem inalteradas, produzindo um padrão que corresponde a toda sequência possível do motivo.`)
};

const pt_iupac_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada código é substituído por uma classe de caracteres com as bases que representa — N torna-se [ACGT], R torna-se [AG] — e as bases simples são deixadas inalteradas, produzindo um padrão que corresponde a todas as sequências possíveis do motivo.`)
};

const ja_iupac_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各コードは、それが表す塩基の文字クラスに置き換えられます — Nは[ACGT]に、Rは[AG]になります — 通常の塩基はそのまま残り、モチーフのすべての可能な配列に一致するパターンが生成されます。`)
};

const zh_iupac_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个简并码都会被替换为其所代表碱基的字符类——N 变为 [ACGT]，R 变为 [AG]——而普通碱基保持不变，从而生成一个能匹配该模体所有可能序列的模式。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iupac_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iupac_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iupac_faq_a2", locale)
	if (locale === "en") return en_iupac_faq_a2(inputs)
	if (locale === "es") return es_iupac_faq_a2(inputs)
	if (locale === "de") return de_iupac_faq_a2(inputs)
	if (locale === "nl") return nl_iupac_faq_a2(inputs)
	if (locale === "fr") return fr_iupac_faq_a2(inputs)
	if (locale === "it") return it_iupac_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_iupac_faq_a2(inputs)
	if (locale === "pt") return pt_iupac_faq_a2(inputs)
	if (locale === "ja") return ja_iupac_faq_a2(inputs)
	return zh_iupac_faq_a2(inputs)
};